import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme/theme';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import UserProfile from './common/components/Profile/UserProfile';
import Layout from './common/components/Layout';
import CurrencyPreference from './common/components/CurrencyPreference/CurrencyPreference';
import PrivacyPolicy from './common/components/PrivacyPolicy/PrivacyPolicy';
import Collections from './common/components/Collections/Collections';
import MyStats from './common/components/MyStats/MyStats';
import MarketPlace from './common/components/MarketPlace/MarketPlace';
import Directory from './common/components/Directory/Directory';
import Items from './common/components/Items/Items';
import TermsAndConditions from './common/components/TermsAndConditions/TermsAndConditions';
import DataDeletion from './common/components/DataDeletion/DataDeletion';
import MarketListing from './common/components/MarketPlace/MarketListing';
import { LoginContext } from './lib/context';

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout><App /></Layout>,
  },
  {
    path: "userprofile/:userId",
    element: <Layout><UserProfile /></Layout>
  },
  {
    path: "currencypreference",
    element: <Layout> <CurrencyPreference /></Layout>
  },
  {
    path: "privacypolicy",
    element: <Layout><PrivacyPolicy /></Layout>
  },
  {
    path: "collections",
    element: <Layout><Collections /></Layout>
  },
  {
    path: "mystats/:userId",
    element: <Layout><MyStats /></Layout>
  },
  {
    path: "marketplace",
    element: <Layout><MarketPlace /></Layout>
  },
  {
    path: "marketplace/:listId",
    element: <Layout><MarketListing /></Layout>
  },
  {
    path: "directory",
    element: <Layout><Directory /></Layout>
  },
  {
    path: "items",
    element: <Layout><Items /></Layout>
  },
  {
    path: "termsandconditions",
    element: <Layout><TermsAndConditions /></Layout>
  },
  {
    path: "datadeletion",
    element: <Layout><DataDeletion /></Layout>
  },
]);

const Index = () => {
  const [login, setLogin] = useState(null);

  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LoginContext.Provider
          value={{
            login,
            setLogin
          }}
        >
          <RouterProvider router={router} />
        </LoginContext.Provider>
      </ThemeProvider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Index />);

